export default __webpack_public_path__ + "static/media/October2021.53e911c7.png";